/* PlusCards recent purchase toast - see snippets/pc-social-proof.liquid */
(function () {
  var toast = document.getElementById('pc-toast');
  if (!toast) return;

  var maxToasts = parseInt(toast.getAttribute('data-max') || '3', 10);
  var collection = toast.getAttribute('data-collection') || 'best-sellers';
  var shown = 0;
  try { shown = parseInt(sessionStorage.getItem('pc-toast-count') || '0', 10); } catch (e) {}
  if (shown >= maxToasts) return;

  var img = document.getElementById('pc-toast-img');
  var name = document.getElementById('pc-toast-product');
  var time = document.getElementById('pc-toast-time');
  var closeBtn = document.getElementById('pc-toast-close');
  var products = [];
  var index = 0;
  var hideTimer = null;

  var timeLabels = [
    'Just now', '2 min ago', '4 min ago', '7 min ago', '11 min ago', '15 min ago',
    '20 min ago', '26 min ago', '34 min ago', '45 min ago', '1 hr ago', '2 hrs ago'
  ];

  fetch('/collections/' + collection + '/products.json?limit=12')
    .then(function (r) { return r.ok ? r.json() : { products: [] }; })
    .then(function (data) {
      products = (data.products || []).filter(function (p) {
        return p.images && p.images.length && p.variants && p.variants.some(function (v) { return v.available; });
      });
      if (products.length) {
        shuffle(products);
        scheduleNext(8000);
      }
    })
    .catch(function () {});

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
  }

  function scheduleNext(base) {
    setTimeout(show, base + Math.random() * 12000);
  }

  function show() {
    if (shown >= maxToasts || !products.length) return;
    var p = products[index % products.length];
    index++;

    var src = p.images[0].src;
    img.src = src.replace(/(\.[^.\/]+)(\?.*)?$/, '_160x$1$2');
    img.alt = p.title;
    name.textContent = p.title;
    name.href = '/products/' + p.handle;
    time.textContent = timeLabels[Math.floor(Math.random() * timeLabels.length)];

    toast.classList.add('pc-toast--active');
    toast.setAttribute('aria-hidden', 'false');
    shown++;
    try { sessionStorage.setItem('pc-toast-count', String(shown)); } catch (e) {}

    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      hide();
      if (shown < maxToasts) scheduleNext(18000);
    }, 7000);
  }

  function hide() {
    toast.classList.remove('pc-toast--active');
    toast.setAttribute('aria-hidden', 'true');
  }

  closeBtn.addEventListener('click', function () {
    clearTimeout(hideTimer);
    hide();
    shown = maxToasts;
    try { sessionStorage.setItem('pc-toast-count', String(maxToasts)); } catch (e) {}
  });
})();
